import type { News, Activity } from "@/graphql/generated-types";
import { type IVideoState } from "@/interfaces";
import type { VideoProvider } from "@/types";
import { nanoid } from "nanoid";

interface MediaHolder {
  videos?: News["videos"] | Activity["videos"];
}

export default (item: MediaHolder): IVideoState[] => {
  const result: IVideoState[] = [];

  result.push(
    ...(item.videos || []).map((video) => {
      return {
        uuid: nanoid(),
        id: video.id,
        url: video.url,
        type: video.provider as VideoProvider,
      };
    }),
  );

  return result;
};
